import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntuitiveIndication } from '../../models';
import { TranslateModule } from '@ngx-translate/core';
import { RxIntuitiveIndicationButtonComponent } from '../rx-intuitive-indication-button/rx-intuitive-indication-button.component';

@Component({
	selector: 'rx-intuitive-indication-buttons',
	templateUrl: './rx-intuitive-indication-buttons.component.html',
	styleUrls: ['./rx-intuitive-indication-buttons.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		'[class.rx-intuitive-indication-buttons--as-label]': 'asLabel'
	},
	imports: [CommonModule, TranslateModule, RxIntuitiveIndicationButtonComponent]
})
export class RxIntuitiveIndicationButtonsComponent {
	@Input() indicationIds: IntuitiveIndication[] = [];
	@Input() selectedIndicationIds: IntuitiveIndication[] = [];
	@Input() enabledIndicationIds: IntuitiveIndication[] = [];
	@Input() disabled = false;
	/** Read-only diagram: non-interactive chips (icon + label, white background). */
	@Input() asLabel = false;
	@Input() hideIcon = false;
	/** When true, removes top margin on the inner button row (e.g. parent owns spacing). */
	@Input() omitIndicationRowMargin = false;

	@Output() indicationSelected = new EventEmitter<IntuitiveIndication>();

	onIndicationClicked(indicationId: IntuitiveIndication): void {
		if (!this.disabled) {
			this.indicationSelected.emit(indicationId);
		}
	}

	indicationIdTrackBy(index: number, indicationId: IntuitiveIndication): number {
		return indicationId;
	}

	isIndicationDisabled(indicationId: IntuitiveIndication): boolean {
		if (this.asLabel) {
			return false;
		}

		return this.disabled || !this.enabledIndicationIds.includes(indicationId);
	}
}
